/*eslint react-hooks/exhaustive-deps: "off"*/

import Axios from 'axios';
import classnames from 'classnames';
import { MultiSelect } from 'primereact/multiselect';
import React, { useCallback, useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import useProcessRules from 'src/hooks/useProcessRules';
import { URL_PLUGIN } from 'src/parametros';
import CustomErrorMessage from './CustomErrorMessage';
import InputLabel from './InputLabel';

const procesarOpcions = (options) => {
  if (typeof options !== 'object') {
    return [];
  }
  return options
    .map((value) => {
      let valueCmb = `${value.codigo}`;
      let nombre = value.valor;
      if (value.codCore) {
        valueCmb = `${value.codCore}`;
        nombre = value.nombre;
      }
      return { value: valueCmb, nombre };
    })
    .sort((a, b) => {
      if (a.nombre < b.nombre) return -1;
      if (a.nombre > b.nombre) return 1;
      return 0;
    });
};

const SelectMultiple = ({ name, inputs, ...input }) => {

  console.log('SelectMultiple', input);
  const [codCore] = useState(input.longitud);

  const [codDepente, setCodDepente] = useState(null);
  const [url, setUrl] = useState('');
  const [options, setOptions] = useState([]);
  const methods = useFormContext();
  const { watch, control, formState: { errors }, setValue } = methods;
  const { processValidations, setLoading, loading } = useProcessRules(input);

  const { cotizacion }: any = useSelector<any>((state) => state.Cotizacion);
  const { broker } = cotizacion;

  const getData = useCallback(async () => {
    console.log('SelectMultiple2', input);
    setLoading(true);
    const { data } = await Axios.get(
      `${URL_PLUGIN}listar-desplegables&empCodigo=${broker}&codCore=${codCore}`,
    );

    const { nivel, url, data: opciones, codCoreDepend } = data;

    switch (nivel) {
      case '1':
        if (opciones && opciones.length > 0) {
          setOptions(procesarOpcions(opciones));
        } else if (url && url !== '') {
          const { data: res } = await Axios.get(url);
          if (res.transaccion && res.data.length > 0) {
            setOptions(procesarOpcions(res.data));
          }
        }
        break;
      case '2':
        const item = inputs.find(({ longitud }) => longitud === codCoreDepend);
        setCodDepente(item.codCore);
        setUrl(url);
        const valueDepend = watch(item.codCore);
        if (valueDepend && valueDepend !== '' && typeof valueDepend !== 'object') {
          const keyValue = valueDepend.split('|');
          if (keyValue) {
            const options = await getDataLeve2(keyValue, url);
            setOptions(procesarOpcions(options));
          }
        }
        break;
      default:
        break;
    }
    setLoading(false);
  }, []);
  const dependiente = watch(codDepente);

  useEffect(() => {
    getData();
  }, []);

  const getDataLeve2 = async ([codCore, nombre], url) => {
    setLoading(true);
    if (url && url !== '') {
      let newUrl = url.replace('{{valor}}', codCore).replace('&marCodigoCore', '');
      const { data: res } = await Axios.get(newUrl);
      if (res.transaccion) {
        if (res.data) {
          setLoading(false);
          return res.data;
        } else {
          let newUrl = url.replace('{{valor}}', nombre).replace('&marCodigoCore', '');
          const { data: res } = await Axios.get(newUrl);
          if (res.transaccion) {
            setLoading(false);
            return res.data;
          }
          setLoading(false);
          return [];
        }
      } else {
        let newUrl = url.replace('{{valor}}', nombre).replace('&marCodigoCore', '');
        const { data: res } = await Axios.get(newUrl);
        if (res.transaccion) {
          setLoading(false);
          return res.data;
        }
        setLoading(false);
        return [];
      }
    } else {
      setLoading(false);
      return [];
    }
  };
  const validarDefaultValue = () => {
    const value = watch(name);
    if (value !== undefined && typeof value !== 'object') {
      const keys = value.split('|')[0];
      if (!!!keys[0]) {
        setValue(name, '');
      }
    }
  };

  useEffect(() => {
    if (dependiente && typeof dependiente !== 'object' && url && url !== '') {
      const keyValue = dependiente.split('|');
      if (keyValue) {
        setValue(name, '');
        getDataLeve2(keyValue, url).then((options) => {
          setOptions(procesarOpcions(options));
        });
      }
    } else {
      //setOptions([]);
      //setValue(name, "")
    }
  }, [dependiente]);

  useEffect(() => {
    validarDefaultValue();
  }, []);

  console.log('input', input?.editable, inputs);

  const rules = processValidations();
  return (
    <React.Fragment>
      <span className="p-float-label">
        <Controller
          control={control}
          name={name}
          rules={rules}
          defaultValue={[]}
          render={({ field: { onChange, value } }) => {
            
            try {
              value = value.map((item) => item.split('|')[0])
            } catch (e) { value = value }
            return (
              <MultiSelect
                filter
                id={input.id + ''}
                dataKey="value"
                options={options}
                optionLabel="nombre"
                optionValue="value"
                filterBy="nombre"

                className={classnames({
                  'w-100': true,
                  'p-invalid': !!errors[name],
                })}
                disabled={input?.disabled}
                onChange={(event) => {
                  
                  const valores = event.value.map(val => {
                    const valor = options.find(item => item?.value === val)
                    return valor ? `${val}|${valor.nombre}` : val
                  })
                  onChange(valores);
                  
                }}
                placeholder={loading ? 'CARGANDO...' : ''}
                value={value}
                selectedItemsLabel="{0} Items seleccionados"
                emptyFilterMessage="No se han encontrado resultados"
              />
            );
          }}
        />
        <InputLabel input={input} rules={rules} />
      </span>

      <CustomErrorMessage name={name} />
    </React.Fragment>
  );
};

export default SelectMultiple;
